/* src/app/modules/notification/components/notifications-skeleton/notifications-skeleton.component.scss */
/*# sourceMappingURL=notifications-skeleton.component.css.map */
